// extracted by mini-css-extract-plugin
export default {"cUserDropdown":"UserDropdownMenu_cUserDropdown__NDKsz"};